export interface GeoLocation {
  ip: string;
  lat: number;
  lng: number;
  city: string;
  region: string
  country: string;
}

export async function getUserLocation(): Promise<GeoLocation | null> {
  try {
    const res = await fetch('http://ip-api.com/json/');
    const data = await res.json();

    // {"status":"success","country":"United States","countryCode":"US","region":"GA","regionName":"Georgia","city":"Smyrna","zip":"30080","lat":33.8775,"lon":-84.5017,"timezone":"America/New_York","isp":"AT\u0026T Enterprises, LLC","org":"AT\u0026T Services, Inc","as":"AS7018 AT\u0026T Enterprises, LLC","query":"99.155.144.80"}
    if (data.status !== 'success') {
      console.warn('Failed to get location:', data.message);
      return null;
    }

    return {
      ip: data.query,
      region: data.regionName,
      lat: data.lat,
      lng: data.lon,
      city: data.city,
      country: data.country,
    };
  } catch (error) {
    console.error('Error getting user location:', error);
    return null;
  }
}
